export default "<app-stage\n  class=\"stage\"\n  [ratio]=\"ratio | async\"\n>\n</app-stage>\n<app-sidebar class=\"sidebar\"></app-sidebar>";